var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',_vm._g({attrs:{"title":_vm.formType === 'login' ? 'Login with Facebook' : 'Sign up with Facebook'}},_vm.formType === 'login' ? { click: _vm.logInWithFacebook } : { click: _vm.socialSignUp }),[_c('FacebookIcon'),_vm._v(" "),_c('span',[_vm._v("\n    Facebook\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }